import { render, staticRenderFns } from "./speedTest.vue?vue&type=template&id=551ec331&scoped=true&"
import script from "./speedTest.vue?vue&type=script&lang=js&"
export * from "./speedTest.vue?vue&type=script&lang=js&"
import style0 from "./speedTest.vue?vue&type=style&index=0&id=551ec331&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ec331",
  null
  
)

export default component.exports